import { parseObjByString } from "../../../utils";

const FilterNumberInput = ({
    name,
    label,
    placeholder = "Any",
    register,
    errors,
    onChange,
    min = 0,
}) => {
    const fieldError = errors?.[name] ?? parseObjByString(errors, name)[0];

    return (
        <div className="flex w-full flex-col gap-1.5">
            {label ? (
                <label htmlFor={name} className="text-xs font-semibold uppercase tracking-wide text-nt-grey">
                    {label}
                </label>
            ) : null}
            <input
                id={name}
                type="number"
                min={min}
                placeholder={placeholder}
                className="h-[42px] w-full rounded-xl border border-nt-grey-light bg-white px-3 text-sm text-nt-blue placeholder:text-nt-grey transition focus:border-nt-blue focus:outline-none focus:ring-1 focus:ring-nt-blue"
                {...register(name, { onChange })}
            />
            {fieldError?.message ? (
                <span className="text-xs text-red">{fieldError.message}</span>
            ) : null}
        </div>
    );
};

export { FilterNumberInput };
